"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles = ({ palette }) => ({
    txRow: {
        display: 'flex',
        flexFlow: 'row',
        textAlign: 'left',
        width: '100%',
        cursor: 'pointer',
    },
    txField: {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        '&.cleared': {
            fontWeight: 500,
        },
    },
    listRoot: {
        paddingLeft: 2,
        paddingRight: 2,
        paddingTop: 0,
        paddingBottom: 2,
    },
    listFooter: {
        overflow: 'visible',
    },
    selectedItem: {
        backgroundColor: palette.action.selected,
    },
    colsWrapper: {
        width: '100%',
        display: 'flex',
        flexFlow: 'row',
    },
    divListItem: {
        background: palette.background.subtle,
        textAlign: 'center',
    },
    titleWrapper: {
        width: '100%',
        background: palette.info.main,
        textAlign: 'center',
        color: palette.text.primary,
    },
    divTxnRow: {
        paddingLeft: 2,
        paddingRight: 2,
        overflow: 'hidden',
    },
    divListItemColumn: {
        wordBreak: 'keep-all',
        paddingLeft: 4,
        paddingRight: 4,
    },
});
exports.default = styles;
